import React, { useState } from 'react';
import '@/App.css';
import { Toaster } from 'sonner';

import { IDX_SEARCH_URL } from './constants/site';
import { NAV_ITEMS } from './constants/nav';
import { useHomeModals } from './hooks/useHomeModals';
import { useHashScroll } from './hooks/useHashScroll';

import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { GuideModal } from './components/modals/GuideModal';
import { PrivacyPolicyModal } from './components/modals/PrivacyPolicyModal';
import { RelocationGuideModal } from './components/modals/RelocationGuideModal';
import { HeroSection } from './components/sections/HeroSection';
import { FeaturedListingsSection } from './components/sections/FeaturedListingsSection';
import { SellerAreasSection } from './components/sections/SellerAreasSection';
import { MilitarySection } from './components/sections/MilitarySection';
import { AboutSection } from './components/sections/AboutSection';
import { AsSeenOnTVSection } from './components/sections/AsSeenOnTVSection';
import { PropertiesSection } from './components/sections/PropertiesSection';
import { RelocationGuidesSection } from './components/sections/RelocationGuidesSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { GoogleReviewsSection } from './components/sections/GoogleReviewsSection';
import { BlogSection } from './components/sections/BlogSection';
import { ContactSection } from './components/sections/ContactSection';

// Stable references for <Toaster /> to avoid re-creating on every render.
const TOASTER_TOAST_OPTIONS = { style: { fontFamily: 'inherit' } };

const openIdxSearch = (query) => {
  const target = query.trim() ? `${IDX_SEARCH_URL}#${encodeURIComponent(query)}` : IDX_SEARCH_URL;
  window.open(target, '_blank');
};

const App = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const modals = useHomeModals();
  useHashScroll();

  const handleSearch = (e) => {
    e.preventDefault();
    openIdxSearch(searchQuery);
  };

  return (
    <div className="min-h-screen bg-sand-50">
      <Navbar navItems={NAV_ITEMS} />

      <HeroSection searchQuery={searchQuery} setSearchQuery={setSearchQuery} handleSearch={handleSearch} openGuideModal={modals.openGuideModal} openPrivacyPolicy={modals.openPrivacyPolicy} />
      <FeaturedListingsSection />
      <SellerAreasSection />
      <MilitarySection />
      <AboutSection />
      <AsSeenOnTVSection />
      <PropertiesSection />
      <RelocationGuidesSection openRelocationGuide={modals.openRelocationGuide} />
      <TestimonialsSection />
      <GoogleReviewsSection />
      <BlogSection openPrivacyPolicy={modals.openPrivacyPolicy} />
      <ContactSection openPrivacyPolicy={modals.openPrivacyPolicy} />

      <Footer navItems={NAV_ITEMS} openPrivacyPolicy={modals.openPrivacyPolicy} />

      <GuideModal {...modals.guide} openPrivacyPolicy={modals.openPrivacyPolicy} />
      <PrivacyPolicyModal {...modals.privacy} />
      <RelocationGuideModal {...modals.relocation} openPrivacyPolicy={modals.openPrivacyPolicy} />

      <FloatingCTA />
      <Toaster position="top-center" richColors closeButton toastOptions={TOASTER_TOAST_OPTIONS} />
    </div>
  );
};

export default App;
